import {Injectable} from '@angular/core';

@Injectable()
export class TimeFormatterService {
  timeList: any;

  constructor() {
  }

  formatTime(formatedTime) {
    this.timeList = null;

    // if (formatedTime != null) {
      this.timeList = formatedTime;

      // // workStart
      // if (this.timeList.workStart.hour !== 'undefined') {
      //   if (this.timeList.workStart.hour < 10) {
      //     this.timeList.workStart.hour = '0' + this.timeList.workStart.hour;
      //   }
      // }
      // if (this.timeList.workStart.minute !== 'undefined') {
      //   if (this.timeList.workStart.minute < 10) {
      //     this.timeList.workStart.minute = '0' + this.timeList.workStart.minute;
      //   }
      // }
      // // workEnd
      // if (this.timeList.workEnd.hour !== 'undefined') {
      //   if (this.timeList.workEnd.hour < 10) {
      //     this.timeList.workEnd.hour = '0' + this.timeList.workEnd.hour;
      //   }
      // }
      // if (this.timeList.workEnd.minute !== 'undefined') {
      //   if (this.timeList.workEnd.minute < 10) {
      //     this.timeList.workEnd.minute = '0' + this.timeList.workEnd.minute;
      //   }
      // }
      // // First break start
      // if (this.timeList.firstBreakStart.hour !== 'undefined') {
      //   if (this.timeList.firstBreakStart.hour < 10) {
      //     this.timeList.firstBreakStart.hour = '0' + this.timeList.firstBreakStart.hour;
      //   }
      // }
      // if (this.timeList.firstBreakStart.minute !== 'undefined') {
      //   if (this.timeList.firstBreakStart.minute < 10) {
      //     this.timeList.firstBreakStart.minute = '0' + this.timeList.firstBreakStart.minute;
      //   }
      // }
      // // First break end
      // if (this.timeList.firstBreakEnd.hour !== 'undefined') {
      //   if (this.timeList.firstBreakEnd.hour < 10) {
      //     this.timeList.firstBreakEnd.hour = '0' + this.timeList.firstBreakEnd.hour;
      //   }
      // }
      // if (this.timeList.firstBreakEnd.minute !== 'undefined') {
      //   if (this.timeList.firstBreakEnd.minute < 10) {
      //     this.timeList.firstBreakEnd.minute = '0' + this.timeList.firstBreakEnd.minute;
      //   }
      // }
      // // Lunch start
      // if (this.timeList.lunchStart.hour !== 'undefined') {
      //   if (this.timeList.lunchStart.hour < 10) {
      //     this.timeList.lunchStart.hour = '0' + this.timeList.lunchStart.hour;
      //   }
      // }
      // if (this.timeList.lunchStart.minute !== 'undefined') {
      //   if (this.timeList.lunchStart.minute < 10) {
      //     this.timeList.lunchStart.minute = '0' + this.timeList.lunchStart.minute;
      //   }
      // }
      // // Lunch end
      // if (this.timeList.lunchEnd.hour !== 'undefined') {
      //   if (this.timeList.lunchEnd.hour < 10) {
      //     this.timeList.lunchEnd.hour = '0' + this.timeList.lunchEnd.hour;
      //   }
      // }
      // if (this.timeList.lunchEnd.minute !== 'undefined') {
      //   if (this.timeList.lunchEnd.minute < 10) {
      //     this.timeList.lunchEnd.minute = '0' + this.timeList.lunchEnd.minute;
      //   }
      // }
      // // Second break start
      // if (this.timeList.secondBreakStart.hour !== 'undefined') {
      //   if (this.timeList.secondBreakStart.hour < 10) {
      //     this.timeList.secondBreakStart.hour = '0' + this.timeList.secondBreakStart.hour;
      //   }
      // }
      // if (this.timeList.secondBreakStart.minute !== 'undefined') {
      //   if (this.timeList.secondBreakStart.minute < 10) {
      //     this.timeList.secondBreakStart.minute = '0' + this.timeList.secondBreakStart.minute;
      //   }
      // }
      // // Second break end
      // if (this.timeList.secondBreakEnd.hour !== 'undefined') {
      //   if (this.timeList.secondBreakEnd.hour < 10) {
      //     this.timeList.secondBreakEnd.hour = '0' + this.timeList.secondBreakEnd.hour;
      //   }
      // }
      // if (this.timeList.secondBreakEnd.minute !== 'undefined') {
      //   if (this.timeList.secondBreakEnd.minute < 10) {
      //     this.timeList.secondBreakEnd.minute = '0' + this.timeList.secondBreakEnd.minute;
      //   }
      // }
    // }
    return this.timeList;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/time-formatter.service.ts